import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, toDisplayString as _toDisplayString, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, resolveComponent as _resolveComponent, createVNode as _createVNode, vShow as _vShow, withDirectives as _withDirectives, createBlock as _createBlock, createElementVNode as _createElementVNode, normalizeClass as _normalizeClass, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-02969175"),n=n(),_popScopeId(),n)
const _hoisted_1 = {
  key: 0,
  class: "report-header__date"
}
const _hoisted_2 = { class: "report-header__actions" }
const _hoisted_3 = { key: 0 }
const _hoisted_4 = { key: 1 }
const _hoisted_5 = { key: 0 }
const _hoisted_6 = { key: 1 }
const _hoisted_7 = {
  key: 0,
  class: "report-header__info"
}

import { computed, PropType } from 'vue'
import { useRoute, useRouter } from 'vue-router'
import { UnionReportType } from '@/widgets/WReportHeader/types/union.type'
import { FRemoveReport } from '@/features/FRemoveReport'
import { FDownloadReport } from '@/features/FDownloadReport'
import { ReportViewType } from '@/shared/types'
import { getDateFormat } from '@/shared/utils'
import { DATE_FORMAT, REPORT_VIEW } from '@/shared/constants'
import { useOrganizationModules } from '@/shared/composables'

interface Props {
  reportInfo: UnionReportType
  reportType: ReportViewType
  position?: 'top' | 'bottom'
  isOld?: boolean
  isLockPreview?: boolean
}


export default /*#__PURE__*/_defineComponent({
  props: {
    reportInfo: null,
    reportType: null,
    position: null,
    isOld: { type: Boolean },
    isLockPreview: { type: Boolean }
  },
  setup(__props: any) {

const props = __props as {
  reportInfo: UnionReportType
  reportType: ReportViewType
  position?: 'top' | 'bottom'
  isOld?: boolean
  isLockPreview?: boolean
}



const { organizationModules } = useOrganizationModules()

const route = useRoute()
const router = useRouter()

const reportId = computed(() => Number(route.params.reportId))
const patientId = computed(() => route.params.patientId.toString())
const isPreviewMode = computed(() => route.query['view-mode'] === '1')
const isOverlayMode = computed(() => route.query['overlay-mode'] === '1')
const viewIcon = computed(() => (isPreviewMode.value ? 'close-view' : 'view'))

const date = computed((): string =>
  props.reportInfo.date_at
    ? getDateFormat(new Date(props.reportInfo.date_at), DATE_FORMAT.dmyLong)
    : ''
)

const handleChangeViewMode = (): void => {
  let query = {}
  if (isOverlayMode.value) {
    query['overlay-mode'] = 1
  }

  if (!isPreviewMode.value) {
    query['view-mode'] = 1
  }

  router.push({ query })
}

const handleChangeOverlayMode = (): void => {
  let query = {}
  if (!isOverlayMode.value) {
    query['overlay-mode'] = 1
  }

  if (isPreviewMode.value) {
    query['view-mode'] = 1
  }

  router.push({ query })
}

const mapper = {
  plaqueIndex: 'plaque',
  periodontal: 'periodontology',
  screening: 'screening',
  brushMap: 'brushmap',
  riskMap: 'riskmap',
}

const editAvailable = computed<boolean>(
  () => organizationModules.value.indexOf(mapper[props.reportType]) > -1
)

return (_ctx: any,_cache: any) => {
  const _component_icon_template = _resolveComponent("icon-template")!

  return (_openBlock(), _createElementBlock("div", {
    class: _normalizeClass(["report-header", { 'report-header_bottom': __props.position === 'bottom' }])
  }, [
    _createElementVNode("div", {
      class: _normalizeClass(["report-header__content", { 'report-header__content_preview': _unref(isPreviewMode) }])
    }, [
      (!_unref(isPreviewMode))
        ? (_openBlock(), _createElementBlock("div", _hoisted_1, _toDisplayString(_unref(date)), 1))
        : _createCommentVNode("", true),
      _createElementVNode("div", _hoisted_2, [
        (
            __props.reportType === _unref(REPORT_VIEW).periodontal &&
            _unref(patientId) !== 'null-patient' &&
            !__props.isOld
          )
          ? (_openBlock(), _createElementBlock("button", {
              key: 0,
              class: "report-header__navigation-item",
              type: "button",
              onClick: handleChangeOverlayMode
            }, [
              _createVNode(_component_icon_template, {
                name: _unref(viewIcon),
                class: "report-header__navigation-icon",
                height: "12",
                width: "12"
              }, null, 8, ["name"]),
              (!_unref(isOverlayMode))
                ? (_openBlock(), _createElementBlock("span", _hoisted_3, "Режим наложения"))
                : (_openBlock(), _createElementBlock("span", _hoisted_4, "Выйти из режима наложения"))
            ]))
          : _createCommentVNode("", true),
        (_unref(patientId) !== 'null-patient' && !__props.isOld && !__props.isLockPreview)
          ? (_openBlock(), _createElementBlock("button", {
              key: 1,
              class: "report-header__navigation-item",
              type: "button",
              onClick: handleChangeViewMode
            }, [
              _createVNode(_component_icon_template, {
                name: _unref(viewIcon),
                class: "report-header__navigation-icon",
                height: "12",
                width: "12"
              }, null, 8, ["name"]),
              (!_unref(isPreviewMode))
                ? (_openBlock(), _createElementBlock("span", _hoisted_5, "Режим демонстрации"))
                : (_openBlock(), _createElementBlock("span", _hoisted_6, "Выйти из режима демонстрации"))
            ]))
          : _createCommentVNode("", true),
        _createVNode(_unref(FDownloadReport), {
          "patient-id": _unref(patientId),
          "report-id": _unref(reportId),
          "report-type": __props.reportType
        }, null, 8, ["patient-id", "report-id", "report-type"]),
        (!_unref(isPreviewMode))
          ? _withDirectives((_openBlock(), _createBlock(_unref(FRemoveReport), {
              key: 2,
              "patient-id": _unref(patientId),
              "report-id": _unref(reportId),
              "report-type": __props.reportType
            }, null, 8, ["patient-id", "report-id", "report-type"])), [
              [_vShow, _unref(editAvailable)]
            ])
          : _createCommentVNode("", true)
      ])
    ], 2),
    (!_unref(isPreviewMode))
      ? (_openBlock(), _createElementBlock("div", _hoisted_7, " Отчёт №" + _toDisplayString(__props.reportInfo.id) + " · Врач: " + _toDisplayString(__props.reportInfo.doctor?.name) + " · " + _toDisplayString(__props.reportInfo.doctor?.position), 1))
      : _createCommentVNode("", true)
  ], 2))
}
}

})